"use client";

import { SpeedInsights as VercelSpeedInsights } from "@vercel/speed-insights/react";
import { env } from "@/lib/env";

export function SpeedInsights() {
  if (env.NEXT_PUBLIC_ENABLE_VERCEL_INSIGHTS !== true) return null;
  return <VercelSpeedInsights />;
}
